<template>
  <div id="m0-check-list-report" class="vs-loading-color-white">
    <div id="m0-check-list-report-header">
      <div class="header-text">
        <span class="sdf-text-22-700-white">M0チェックリスト</span>
      </div>
      <router-link
        id="header-button"
        :to="{ name: 'addon-secure-dataflow-check-list-trend-data-report' }">
        <feather-icon
          class="clipboard-icon"
          icon="ClipboardIcon"
          svg-classes="h-5 w-5 stroke-current text-white"
        />
        <span class="link-to-subtitle sdf-text-16-400-white">M0トレンドデータレポート</span>
      </router-link>
      <span class="header-separator">
      </span>
      <div class="communication-channel-area">
        <vessel-communication-channel />
      </div>
    </div>
    <div id="m0-check-list-main">
      <div class="side-container">

        <div class="condition-year-month">
          <vs-dropdown vs-trigger-click class="dropdown">
            <div  class="flex">
              <div class="vx-col w-5/6 flex items-center justify-start">
                <span class="sdf-text-16-400-white">{{ selectedYearMonth.name }}</span>
              </div>
              <div class="vx-col w-1/6 flex items-center justify-end">
                <feather-icon icon="TriangleIcon" svgClasses="fill-current h-4 w-4" class="allow-down" />
              </div>
            </div>

            <vs-dropdown-menu class="dropdown-menu">
              <vs-dropdown-item v-for="(yearMonth, index) in yearMonthList" :key="index" @click="onChangeYearMonth(yearMonth)" class="dropdown-item" >
                <span class="sdf-text-16-400-white">{{ yearMonth.name }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div class="m0-check-list-area">
          <div class="m0-check-list-header">
            <div class="column-header-text column-datetime"><span class="sdf-text-14-400-mouse-gray">日時</span></div>
          </div>
          <div class="data-record-list">
            <div v-for="record in dataRecordList"
                :key="record.id"
                @click="onClickDataRecord(record)"
                class="data-record"
                :class="[ record.id === getSelectedM0CheckListId ? 'selected-m0-check-list' : '' ]"
            >
              <div class="column-datetime"><span class="sdf-text-18-400-white">{{record.start_at}}</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-container">
        <div>
          <m0-check-list-rooms></m0-check-list-rooms>
        </div>
        <div>
          <m0-check-list-items
            :items="items"
          ></m0-check-list-items>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from "vue"
import M0CheckListItems from "./components/M0CheckListItems";
import M0CheckListRooms from "./components/M0CheckListRooms";
import VesselCommunicationChannel from "../../components/VesselCommunicationChannel";
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin";
import {createNamespacedHelpers} from "vuex";
const { mapGetters, mapActions, mapState } = createNamespacedHelpers("m0CheckListReport");
import moment from "moment";
import SecureDataflowService from "@/services/secureDataflowService";

// Mixin
import {
  StoreCommonsMixin,
  StoreMenuMixin,
  MappingTableMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

export default {
  name: "M0CheckListReport",
  mixins: [
    SecureDataflowMixin,
    StoreCommonsMixin,
    StoreMenuMixin,
    MappingTableMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  components: {
    M0CheckListRooms,
    M0CheckListItems,
    VesselCommunicationChannel
  },
  data() {
    return {
      selectedYearMonth: {
        name: 'YYYY年MM月',
        timeValueJST: 0,
      },
      yearMonthList: [],
      dataRecordList: [],
      items: [],

      intervalId: null,
      timer: null,
      maneuveringLastUpdatedAt: null,
      maneuveringLastUpdateAtString: null,
      engineLastUpdatedAt: null,
      lastUpdateAt: null,
    }
  },
  computed: {
    ...mapGetters(["getSelectedM0CheckListId", "getSselectedRoom", "getRooms"]),
    ...mapState({
      selectedRoomId: state => state.selectedRoomId,
      selectedEditHistoryId: state => state.selectedEditHistoryId,
    }),

    operationMode() {
      if (this.channelDataManeuvering) {
        return `${this.getOperationModeLabel(
          this.channelDataManeuvering.SB44.vs
        )}`;
      }
    }
  },
  watch: {
    selectedRoomId() {
      if ( this.selectedRoomId >= 0 ){
        this.onChangeSelectedRoomId();
      }
    },
    selectedEditHistoryId() {
      if ( this.selectedEditHistoryId >= 0 ){
        this.onChangeSelectedEditHistoryId();
      }
    },

    channelDataManeuvering(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.maneuveringLastUpdatedAt = moment.unix(
          val.last_updated_at.seconds
        );
        this.updateStateTime();
      }
    },
    channelDataEngine(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.engineLastUpdatedAt = moment.unix(val.last_updated_at.seconds);
        this.updateStateTime();
      }
    }
  },
  methods: {
    ...mapActions([
      "searchDataRecordList", "searchM0CheckListItems", "mergeItemFrameValue",
      "setSelectedM0CheckListId", "setSelectedRoomId", "setSelectedEditHistoryId", "setRoomDatas",
    ]),
    /**
     * 年月リストを生成.
     */
    getYearMonthList: function(){
      let yearMonthList = new Array();
      const duration = 12;
      for (let i = 0  ; i >= -1 * duration ; i--) {
        let timeValueJST = moment(moment().add(i, 'month').format("YYYY-MM-01T00:00:00.000")).valueOf();
        yearMonthList.push({
          name: moment(timeValueJST).format("YYYY年MM月"),
          timeValueJST: timeValueJST,
        });
      }

      this.setSelectedEditHistoryId(-1);
      this.onChangeYearMonth(yearMonthList[0]);

      return yearMonthList;
    },
    /**
     * 指定年月のチェックリストを検索.
     */
    onChangeYearMonth: async function(yearMonth) {
      this.selectedYearMonth = yearMonth;
      this.setSelectedM0CheckListId(-1);
      this.setSelectedRoomId(-1);
      this.setSelectedEditHistoryId(-1);

      // APIをコールして検索.
      this.dataRecordList = await this.searchDataRecordList(yearMonth.timeValueJST);

      // デフォルトで最新のチェックリストを選択.
      if ( this.dataRecordList.length > 0 ) {
        await this.onClickDataRecord(this.dataRecordList[this.dataRecordList.length - 1]);

        this.$nextTick(function () {
          document.getElementsByClassName("data-record-list").forEach(element => {
            element.scrollTop = element.scrollHeight;
          });
        });
      } else {
        this.setRoomDatas([]);
        this.items = [];
      }
    },
    /**
     * 選択したチェックリストの詳細を取得.
     */
    onClickDataRecord: async function (m0CheckList) {

      this.$vs.loading({
        text: "データ取得中",
        textAfter: true,
        color: this.sdfColor.Blue,
        container: '#m0-check-list-report',
      })

      // チェックリスト詳細一式を取得してstoreに保存
      await this.setSelectedM0CheckListId(m0CheckList.id);
      await this.searchM0CheckListItems(m0CheckList);

      // 表示する部分をStoreからチョイスしてマージする
      this.items = await this.mergeItemFrameValue();
      this.$vs.loading.close('#m0-check-list-report > .con-vs-loading');

    },
    /**
     * ルームを変更した時の再表示.
     */
    onChangeSelectedRoomId: async function() {
      this.items = await this.mergeItemFrameValue();
    },
    /**
     * 履歴を変更した時の再表示.
     */
    onChangeSelectedEditHistoryId: async function() {
      this.items = await this.mergeItemFrameValue(this.selectedEditHistoryId);
    },

    updateStateTime() {
      // 最終更新時刻は操船データの最終更新時刻を採用
      if (this.maneuveringLastUpdatedAt) {
        this.maneuveringLastUpdateAtString = this.maneuveringLastUpdatedAt
          .local()
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        this.maneuveringLastUpdateAtString = "--/--/-- --:--:--";
      }
      
      if (this.maneuveringLastUpdatedAt && this.engineLastUpdatedAt) {
        if (this.maneuveringLastUpdatedAt.isAfter(this.engineLastUpdatedAt)) {
          this.lastUpdateAt = this.maneuveringLastUpdatedAt;
        } else {
          this.lastUpdateAt = this.engineLastUpdatedAt;
        }
        this.setWatchConnectionState();
      }
    },
    setWatchConnectionState() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.isDisconnect()) {
        this.setDisconnectState4gVSAT()
      } else {
        // Vue.$log.info(
        //   `[SDF] Stable 4G/VSA connection, last update at ${this.lastUpdateAt.local()}`
        // );
        this.SET_CONNECTING_STATE_4G_VSAT({
          isDisconnect: false,
          localTime: this.lastUpdateAt.local()
        });
        this.setTimerWatchConnectionState();
      }
    },
    setTimerWatchConnectionState() {
      this.timer = setTimeout(() => {
        this.setDisconnectState4gVSAT()
      }, 120000);
    },
    isDisconnect() {
      // 2分超えているかどうか
      return moment().diff(this.lastUpdateAt, "minutes") >= 2;
    },
    setDisconnectState4gVSAT() {
      Vue.$log.warn(
        `[SDF] Disconnect 4G/VSAT, last update at ${this.lastUpdateAt.local()}`
      );
      this.SET_CONNECTING_STATE_4G_VSAT({
        isDisconnect: true,
        localTime: this.lastUpdateAt.local()
      });
    }
  },
  mounted() {
    this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "secureDataflow");
    let routerViewClass = document.getElementsByClassName("router-view");
    routerViewClass[0].style.padding = "0.0rem";

    this.yearMonthList = this.getYearMonthList();
    this.setRoomDatas([]);
  },
  async created() {
    let vessel = await SecureDataflowService.getVessel();
    if (typeof vessel === "undefined") {
      this.SET_SHOW_DIALOG_SELECT_VESSEL(true)
    } else {
      let payload = {
        vesselInfo: vessel.vessel_info,
        maneuveringOriginId: vessel.maneuvering_origin_id,
        engineOriginId: vessel.engine_origin_id,
        alertOriginId: vessel.alert_origin_id,
      };
      await this.setVesselInfoAndVersions(payload);
    }

    this.getInitialFOFlow({
      vesselId: this.vesselInfo.id,
      versionName: this.engineVersion.name
    })

    this.subscribeChannelDataManeuvering({
      vesselId: this.vesselInfo.id,
      versionName: this.maneuveringVersion.name
    });

    this.subscribeChannelDataEngine({
      vesselId: this.vesselInfo.id,
      versionName: this.engineVersion.name
    });

    this.subscribeChannelDataAlert({
      vesselId: this.vesselInfo.id,
      versionName: this.alertVersion.name
    });
  },
  beforeDestroy() {
    this.resetStateOfMonitoringVesselManeuvering();
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";
.title-loading {
  color: $sdf-white;
  font-size: 30px;
}

#m0-check-list-report-header {
  width: 100%;
  height: 83px;
  color: $sdf-white;
  font-size: 22px;
  background: $sdf-black;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  align-items: center;
  .header-text {
    margin-left: 120px;
  }
  #header-button {
    color: $white;
    display: flex;
    margin-left: auto;
    margin-right: 20px;
  }
  .clipboard-icon {
    margin-right: 10px;
  }
  .header-separator {
    background-color: $sdf-mouse-gray;
    width: 1px;
    height: 25px;
  }
  .communication-channel-area {
    margin-right: 35px;
  }
}

#m0-check-list-main {

  min-height: calc(100vh - 83px);
  background-color: $sdf-dark-blue-navy;
  color: $sdf-white;
  display: flex;

  .side-container {
    min-width: 280px;  /* 左枠の幅 */
    padding: 20px;
  }

  .selected-m0-check-list {
    background-color: $sdf-blue;
  }

  .main-container {
    width: 100%;
    padding-left: 30px;
    overflow-y: scroll;
  }

  .m0-check-list-header {
    display: flex;
    border-bottom: solid;
    border-width: 1px;
    border-color: $sdf-gray;
  }

  .m0-check-list-area {
    .column-datetime {
      width: 160px;
    }
    .column-user-name {
      min-width: 140px;
    }
    .column-kind {
      min-width: 40px;
    }

  }

  .data-record-list {
    height: calc(100vh - 220px);
    overflow-y: auto;
    scrollbar-color: $sdf-gray $sdf-dark-blue-navy;
  }

  .data-record {
    display: flex;
    padding: 0.8rem 0;
    border-bottom: solid;
    border-width: 1px;
    border-color: $sdf-gray;
  }

  .condition-year-month {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
    .section-title {
      margin-right: 13px;
      margin-left: 18px;
    }
    .allow-down > svg{
      transform: rotate(180deg);
      color: $sdf-navy;
    }
    .dropdown {
      height: 36px;
      width: 160px;
      border: 2px solid $sdf-navy;
      border-radius: 3px;
      padding: 1px 10px 1px 10px;
    }
  }
}

.dropdown-menu{
  width: 160px;
  :hover {
    background: $sdf-blue;
  }
}
.dropdown-item {
  border: 6px solid $sdf-navy;
  border-radius: 0;
  color: $sdf-white;
  background: $sdf-navy;
  width: 100%;
  margin: 0;
}

</style>
